export class Honor {
    honorID: number;
    contactID: number
    honorsSetID?: number;
    honorDate: Date;
}